var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z","fill":"#2C71F0"}));
}

Info.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Info;

Info.default = Info;
